if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        this.form.querySelectorAll("[name=id]").forEach((el) => {
          el.disabled = false;
        });

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        event.preventDefault();

        const formData = new FormData(this.form);

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) throw new Error("Erro ao adicionar ao carrinho");
            return response.json();
          })
          .then(() => {
            window.location.href = "/cart";
          })
          .catch((error) => {
            console.error(error);
            alert("Não foi possível adicionar o produto ao carrinho.");
          });
      }
    }
  );
}